import * as Yup from "yup";

const commaSeparatedValidation = (
  label: string,
  // maxItems = 5,
  maxItemLength = 100,
) =>
  Yup.string()
    .required(`Please enter ${label}`)
    // .trim(`${label} cannot include leading and trailing spaces`)
    .strict(true)
    // .test(
    //   "max-items",
    //   `You can add a maximum of ${maxItems} ${label}`,
    //   (value) => {
    //     if (!value) return true;

    //     const items = value
    //       .split(",")
    //       .map((item) => item.trim())
    //       .filter((item) => item.length > 0);

    //     return items.length <= maxItems;
    //   },
    // )
    .test(
      "max-item-length",
      `Text should be less than 100 characters`,
      (value) => {
        if (!value) return true;

        const items = value
          .split(",")
          .map((item) => item.trim())
          .filter((item) => item.length > 0);

        return items.every((item) => item.length <= maxItemLength);
      },
    );

export const profileValidation = Yup.object().shape({
  accomplishments: commaSeparatedValidation("Accomplishments"),
  referrals: commaSeparatedValidation("Ideal Referrals"),
  goals: commaSeparatedValidation("Goals"),
  interests: commaSeparatedValidation("Interests"),
  network: commaSeparatedValidation("Network"),
  skills: commaSeparatedValidation("Skills"),
  success: commaSeparatedValidation("My Key to Success"),
  desires: commaSeparatedValidation("My Burning Desire"),
  clients: commaSeparatedValidation("Clients"),
});

/* Questionaries Schema Start */
export const createQuestionariesSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      title: Yup.string()
        //  .required("Main Title is required")
        .max(
          100,
          "Please enter your Main Title with a maximum of 100 characters",
        ),
      // .matches(/^[A-Za-z0-9\s].*$/, "Main Title must not contain spaces"),
      subTitle: Yup.string()
        .required("Sub Title is required")
        .max(100, "Please enter your SubTitle with a maximum of 100 characters")
        .matches(/^[A-Za-z0-9\s].*$/, "subtitle must not contain spaces"),
      sequence: Yup.string()
        .required("Sequence is required")
        .matches(/^[A-Za-z0-9\s].*$/, "sequence must not contain spaces"),
      slug: Yup.string().required("Type is required"),
      tags: Yup.array().of(
        Yup.object().shape({
          sequence: Yup.string().required("Sequence is required"),
          name: Yup.string()
            .required("Name is required")
            .max(
              100,
              "Please enter your Tag Name with a maximum of 100 characters",
            ),
        }),
      ),
      // tags: Yup.string().required("At Least One option field Required"),
    });
  } else {
    return Yup.object().shape({
      title: Yup.string()
        // .required("Main Title is required")
        .max(
          100,
          "Please enter your Main Title with a maximum of 100 characters",
        ),
      // .matches(/^[A-Za-z0-9\s].*$/, "Main Title must not contain spaces"),
      subTitle: Yup.string()
        .required("SubTitle is required")
        .max(100, "Please enter your SubTitle with a maximum of 100 characters")
        .matches(/^[A-Za-z0-9\s].*$/, "subtitle must not contain spaces"),
      sequence: Yup.string()
        .required("Sequence is required")
        .matches(/^[A-Za-z0-9\s].*$/, "sequence must not contain spaces"),
      slug: Yup.string().required("Type is required"),
      tags: Yup.array().of(
        Yup.object().shape({
          sequence: Yup.string().required("Sequence is required"),
          name: Yup.string()
            .required("Name is required")
            .max(
              100,
              "Please enter your Tag Name with a maximum of 100 characters",
            ),
        }),
      ),
    });
  }
};

/* SubTags Schema Start */
export const createSubTagsSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      name: Yup.string()
        .required("SubTag Name is required")
        .max(
          100,
          "Please enter your SubTag Name with a maximum of 100 characters",
        )
        .trim("SubTag Name cannot include leading and trailing spaces")
        .strict(true),
    });
  } else {
    return Yup.object().shape({
      name: Yup.string()
        .required("SubTag Name is required")
        .max(
          100,
          "Please enter your SubTag Name with a maximum of 100 characters",
        )
        .trim("SubTag Name cannot include leading and trailing spaces")
        .strict(true),
    });
  }
};

export const createMasterQuestionSchema = (forEdit: boolean, flag: string) => {
  if (forEdit) {
    return Yup.object().shape({
      title: Yup.string()
        .required("Title is required")
        .max(100, "Please enter your Title with a maximum of 100 characters")
        .trim("Title cannot include leading and trailing spaces")
        .strict(true),
      // .matches(/^[A-Za-z0-9\s].*$/, "Title must not contain spaces"),
      type: Yup.string()
        .required("type is required")
        .matches(/^[A-Za-z0-9\s].*$/, "type must not contain spaces"),
      sequence: Yup.string()
        .required("sequence is required")
        .matches(/^[A-Za-z0-9\s].*$/, "sequence must not contain spaces"),
      value:
        flag === "Textbox"
          ? Yup.array().of(
              Yup.object().shape({
                name: Yup.string().notRequired(),
              }),
            )
          : Yup.array().of(
              Yup.object().shape({
                name: Yup.string().required("name is Required"),
              }),
            ),
    });
  } else {
    return Yup.object().shape({
      title: Yup.string()
        .required("Title is required")
        .max(100, "Please enter your Title with a maximum of 100 characters")
        .trim("Title cannot include leading and trailing spaces")
        .strict(true),
      // .matches(/^[A-Za-z0-9\s].*$/, "Title must not contain spaces"),
      type: Yup.string()
        .required("type is required")
        .matches(/^[A-Za-z0-9\s].*$/, "type must not contain spaces"),
      sequence: Yup.string()
        .required("sequence is required")
        .matches(/^[A-Za-z0-9\s].*$/, "sequence must not contain spaces"),
      value:
        flag === "Textbox"
          ? Yup.array().of(
              Yup.object().shape({
                name: Yup.string().notRequired(),
              }),
            )
          : Yup.array().of(
              Yup.object().shape({
                name: Yup.string().required("name is Required"),
              }),
            ),
    });
  }
};

/* Questionaries Schema End */

// export const createQuestionariessubtagSchema = (forEdit: boolean) => {
//   if (forEdit) {
//     return Yup.object().shape({
//       title: Yup.string()
//         .required("Main Title is required")
//         .matches(/^[A-Za-z0-9\s].*$/, "Main Title must not contain spaces"),
//       subTitle: Yup.string()
//         .required("Sub Title is required")
//         .matches(/^[A-Za-z0-9\s].*$/, "subtitle must not contain spaces"),
//       // subTags: Yup.array().of(
//       //   Yup.object().shape({
//       //     tagName: Yup.string().required("Tag name is required"),
//       //     subTagName: Yup.array().min(
//       //       1,
//       //       "At least one sub tag name is required",
//       //     ),
//       //     subTagId: Yup.array().min(1, "At least one sub tag ID is required"),
//       //   }),
//       // ),
//     });
//   } else {
//     return Yup.object().shape({
//       title: Yup.string()
//         .required("Main Title is required")
//         .matches(/^[A-Za-z0-9\s].*$/, "Main Title must not contain spaces"),
//       subTitle: Yup.string()
//         .required("Sub Title is required")
//         .matches(/^[A-Za-z0-9\s].*$/, "subtitle must not contain spaces"),
//       // subTags: Yup.array().of(
//       //   Yup.object().shape({
//       //     tagName: Yup.string().required("Tag name is required"),
//       //     subTagName: Yup.array().min(
//       //       1,
//       //       "At least one sub tag name is required",
//       //     ),
//       //     subTagId: Yup.array().min(1, "At least one sub tag ID is required"),
//       //   }),
//       // ),
//     });
//   }
// };

//const regExp = ("/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!+@#\\$%\\^&\\*])(?=.{8,})/");

export const LoginFormSchema = Yup.object().shape({
  // email: Yup.string()
  //   .matches(/^\S*$/, "Email must not contain spaces")
  //   .required("Email is required"),
  email: Yup.string()
    .email("Please enter a valid email ID")
    .required("Email is required"),
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password field must contain a minimum of 8 characters")
    .max(16, "Please enter a maximum of 16 characters") // Password field must be less than 16 characters.
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!+@#\\$%\\^&\\*])(?=.{8,})/,
      "Password field must contain at least 1 Uppercase, 1 Lowercase, 1 Special Character, and 1 Number.",
    ),
});

export const otpFormSchema = Yup.object().shape({
  username: Yup.string()
    .matches(/^\S*$/, "Username must not contain spaces")
    .required("Username is required"),
  otp: Yup.string()
    .matches(/^\d{6}$/, "OTP must be exactly 6 digits")
    .required("OTP is required"),
  //mobile: Yup.string()
  //  .required('Mobile number is required')
});

export const sendOtpFormSchema = (isUsername: boolean) => {
  if (isUsername) {
    return Yup.object({
      textField: Yup.string()
        .matches(/^\S*$/, "Username must not contain spaces")
        .required("Username is required"),
      otp: Yup.string()
        .matches(/^\d{6}$/, "OTP must be exactly 6 digits")
        .required("OTP is required"),
    });
  } else {
    return Yup.object({
      textField: Yup.string()
        .required("Mobile Number is required")
        .min(10, "Please enter a valid 10 digits Mobile Number")
        .max(10, "Please enter a valid 10 digits Mobile Number")
        //.matches(/^\d{10}$/, 'Mobile Number must be 10 digits')
        .matches(new RegExp("[0-9]{7}")),
      otp: Yup.string()
        .matches(/^\d{6}$/, "OTP must be exactly 6 digits")
        .required("OTP is required"),
    });
  }
};

export const NewPasswordFormSchema = Yup.object().shape({
  password: Yup.string()
    .required("Please enter New Password")
    .min(8, "New Password field contain minimum 8 characters")
    .max(16, "Please enter maximum 16 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!+@#\\$%\\^&\\*])(?=.{8,})/,
      "Password field must contain at least 1 Uppercase, 1 Lowercase, 1 Special Character and 1 Number",
    ),
  passwordConfirmation: Yup.string()
    .oneOf(
      [Yup.ref("password"), undefined],
      "New Password and Confirm Password does not match",
    )
    .required("Please enter Confirm Password"),
});

export const ChangePasswordFormSchema = Yup.object().shape({
  currentPassword: Yup.string()
    .required("Please enter Current Password")
    .min(8, "Password field contain minimum 8 characters")
    .max(16, "Please enter maximum 16 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!+@#\\$%\\^&\\*])(?=.{8,})/,
      "Current Password field must contain at least 1 Uppercase, 1 Lowercase, 1 Special Character and 1 Number",
    ),
  newPassword: Yup.string()
    .required("Please enter New Password")
    .min(8, "New Password field contain minimum 8 characters")
    .max(16, "Please enter maximum 16 characters") //New Password field must be less then 16 characters.
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!+@#\\$%\\^&\\*])(?=.{8,})/,
      "New Password field must contain at least 1 Uppercase, 1 Lowercase, 1 Special Character and 1 Number",
    ),
  confirmPassword: Yup.string()
    .required("Please enter your Confirm Password.")
    .oneOf(
      [Yup.ref("newPassword")],
      "New Password and Confirm Password does not match",
    ),
});

export const ResetPasswordFormSchema = Yup.object().shape({
  newpassword: Yup.string()
    .required("Please enter New Password")
    .min(8, "New Password field contain minimum 8 characters")
    .max(16, "Please enter maximum 16 characters")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!+@#\\$%\\^&\\*])(?=.{8,})/,
      "New Password field must contain at least 1 Uppercase, 1 Lowercase, 1 Special Character and 1 Number",
    ),
  confirmPassword: Yup.string()
    .oneOf(
      [Yup.ref("newpassword"), undefined],
      "New Password and Confirm Password does not match",
    )
    .required("Please enter Confirm Password"),
});

//export const otpSchema = Yup.string().length(1, 'OTP must be exactly 1 character').matches(/^[0-9]+$/, 'OTP must only contain numbers');
export const otpSchema = Yup.string()
  .matches(/^\d{6}$/, "OTP must be exactly 6 digits")
  .required("OTP is required");

export const createGamesFormSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("The Name cannot include leading and trailing spaces")
        .strict(true),
      full_name: Yup.string()
        .required("Full name is required")
        .max(30, "Please enter your Full name with a maximum of 30 characters")
        .trim("The Full name cannot include leading and trailing spaces")
        .strict(true),
      twitch_id: Yup.string().required("Twitch id is required"),
      pandascore_id: Yup.string().required("Pandascore id is required"),
    });
  } else {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("The Name cannot include leading and trailing spaces")
        .strict(true),
      full_name: Yup.string()
        .required("Full name is required")
        .max(30, "Please enter your Full name with a maximum of 30 characters")
        .trim("The Full name cannot include leading and trailing spaces")
        .strict(true),
      twitch_id: Yup.string().required("Twitch id is required"),
      pandascore_id: Yup.string().required("Pandascore id is required"),
    });
  }
};

export const importCsvFormSchema = Yup.object().shape({
  file: Yup.string().notRequired(),
});

export const createAdvertiseFormSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("The Name cannot include leading and trailing spaces")
        .strict(true),
    });
  } else {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("The Name cannot include leading and trailing spaces")
        .strict(true),
    });
  }
};

export const createPagesFormSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("The Name cannot include leading and trailing spaces")
        .strict(true),
      // description: Yup.string().required("Full name is required").strict(true),
    });
  } else {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("The Name cannot include leading and trailing spaces")
        .strict(true),
      // description: Yup.string().required("Full name is required").strict(true),
    });
  }
};

export const createEmployerFormSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      firstName: Yup.string()
        .required("First name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("The Name cannot include leading and trailing spaces")
        .strict(true),
      lastName: Yup.string()
        .required("Last name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("The Name cannot include leading and trailing spaces")
        .strict(true),
      email: Yup.string()
        .required("Email is required")
        .matches(/^\S*$/, "Email must not contain spaces"),
      mobileNo: Yup.string()
        .required("Mobile No is required")
        .min(10, "Please enter a valid 10 digits Mobile Number")
        .max(10, "Please enter a valid 10 digits Mobile Number")
        .matches(/^\d{10}$/, "Please enter a valid 10 digits Mobile Number"),
      companyName: Yup.string()
        .required("Company Name is required")
        .max(
          30,
          "Please enter your Comapny Name with a maximum of 30 characters",
        )
        .trim("The Company Name cannot include leading and trailing spaces")
        .strict(true),
      companySize: Yup.string()
        .required("Company Size is required")
        .max(
          30,
          "Please enter your Company Title with a maximum of 30 characters",
        )
        .trim("The Company Title cannot include leading and trailing spaces")
        .strict(true),
      companyFounded: Yup.string()
        .required("Company Founded is required")
        .max(
          30,
          "Please enter your Company Title with a maximum of 30 characters",
        )
        .trim("The Company Title cannot include leading and trailing spaces")
        .strict(true),
      companyUrl: Yup.string()
        .required("Company Url is required")
        // .matches(
        //   /^(http|https):\/\/[^ "]+$/,
        //   "Company URL must be a valid URL and start with http or https",
        // )
        .matches(/^(https?)/, "Company URL must start with http or https")
        .trim("The Company Title cannot include leading and trailing spaces")
        .strict(true),
      companyDiversity: Yup.string()
        .required("Company Diversity is required")
        .trim(
          "The Company Diversity cannot include leading and trailing spaces",
        )
        .strict(true),
      companyScore: Yup.number()
        .transform((value, originalValue) => {
          // If the original value is an empty string, transform it to undefined
          return originalValue.trim() === "" ? undefined : value;
        })
        .required("Company Score is required")
        .max(5, "Company Score must not be greater than 5"),
      motivator: Yup.array()
        .required("Motivator is required")
        .min(1, "Please select at least one motivator"),
      companyInfo: Yup.string()
        .required("Company Info is required")
        .trim("The Company Info cannot include leading and trailing spaces")
        .strict(true),
    });
  } else {
    return Yup.object().shape({
      firstName: Yup.string()
        .required("First name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("The Name cannot include leading and trailing spaces")
        .strict(true),
      lastName: Yup.string()
        .required("Last name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("The Name cannot include leading and trailing spaces")
        .strict(true),
      email: Yup.string()
        .required("Email is required")
        .matches(/^\S*$/, "Email must not contain spaces"),
      mobileNo: Yup.string()
        .required("Mobile No is required")
        .min(10, "Please enter a valid 10 digits Mobile Number")
        .max(10, "Please enter a valid 10 digits Mobile Number")
        .matches(/^\d{10}$/, "Please enter a valid 10 digits Mobile Number"),
      password: Yup.string()
        .required("Password is required")
        .min(8, "Password field must contain a minimum of 8 characters")
        .max(16, "Please enter a maximum of 16 characters")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!+@#\\$%\\^&\\*])(?=.{8,})/,
          "Password field must contain at least 1 Uppercase, 1 Lowercase, 1 Special Character, and 1 Number.",
        ),
      confirmpassword: Yup.string()
        .required("Confirm Password is required")
        .oneOf(
          [Yup.ref("password")],
          "Confirm Passwords and Password must match",
        )
        .min(8, "Password field must contain a minimum of 8 characters")
        .max(16, "Please enter a maximum of 16 characters")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!+@#\\$%\\^&\\*])(?=.{8,})/,
          "Password field must contain at least 1 Uppercase, 1 Lowercase, 1 Special Character, and 1 Number.",
        ),
      companyName: Yup.string()
        .required("Company Name is required")
        .max(
          30,
          "Please enter your Comapny Name with a maximum of 30 characters",
        )
        .trim("The Company Name cannot include leading and trailing spaces")
        .strict(true),
      companySize: Yup.string()
        .required("Company Size is required")
        .max(
          30,
          "Please enter your Company Title with a maximum of 30 characters",
        )
        .trim("The Company Title cannot include leading and trailing spaces")
        .strict(true),
      companyFounded: Yup.string()
        .required("Company Founded is required")
        .max(
          30,
          "Please enter your Company Title with a maximum of 30 characters",
        )
        .trim("The Company Title cannot include leading and trailing spaces")
        .strict(true),
      companyUrl: Yup.string()
        .required("Company Url is required")
        // .matches(
        //   /^(http|https):\/\/[^ "]+$/,
        //   "Company URL must be a valid URL and start with http or https",
        // )
        .matches(/^(https?)/, "Company URL must start with http or https")
        .trim("The Company Title cannot include leading and trailing spaces")
        .strict(true),
      companyDiversity: Yup.string()
        .required("Company Diversity is required")
        .trim(
          "The Company Diversity cannot include leading and trailing spaces",
        )
        .strict(true),
      companyScore: Yup.number()
        .transform((value, originalValue) => {
          // If the original value is an empty string, transform it to undefined
          return originalValue.trim() === "" ? undefined : value;
        })
        .required("Company Score is required")
        .max(5, "Company Score must not be greater than 5"),

      motivator: Yup.array()
        .required("Motivator is required")
        .min(1, "Please select At least one motivator"),
      companyInfo: Yup.string()
        .required("Company Info is required")
        .trim("The Company Info cannot include leading and trailing spaces")
        .strict(true),
    });
  }
};

export const createContactFormSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("The Name cannot include leading and trailing spaces")
        .strict(true),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      description: Yup.string()
        .required("Description is required")
        .strict(true),
    });
  } else {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("The Name cannot include leading and trailing spaces")
        .strict(true),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      description: Yup.string()
        .required("Description is required")
        .strict(true),
    });
  }
};

export const createUserFormSchema = (forEdit: boolean) => {
  if (forEdit) {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("The Name cannot include leading and trailing spaces")
        .strict(true),
      first_name: Yup.string()
        .required("Full Name is required")
        .max(50, "Please enter your Full Name with a maximum of 50 characters")
        .trim("The Full Name cannot include leading and trailing spaces")
        .strict(true),
      last_name: Yup.string().required("Last Name is required"),
    });
  } else {
    return Yup.object().shape({
      name: Yup.string()
        .required("Name is required")
        .max(30, "Please enter your Name with a maximum of 30 characters")
        .trim("The Name cannot include leading and trailing spaces")
        .strict(true),
      first_name: Yup.string()
        .required("Full Name is required")
        .max(50, "Please enter your Full Name with a maximum of 50 characters")
        .trim("The Full Name cannot include leading and trailing spaces")
        .strict(true),
      last_name: Yup.string().required("Last Name is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      // password: Yup.string().required("Password is required"),
      password: Yup.string()
        .required("Password is required")
        .min(8, "Password field contain minimum 8 characters")
        .max(16, "Please enter maximum 16 characters")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!+@#\\$%\\^&\\*])(?=.{8,})/,
          "Password field must contain at least 1 Uppercase, 1 Lowercase, 1 Special Character, and 1 Number.",
        ),
      mobile_no: Yup.string().required("Mobile No is required"),
      // description: Yup.string().required("Full name is required").strict(true),
    });
  }
};

/* .min(8, "Password is too short - should be 8 chars minimum.")
    .max(16, "must be less then 16 char")
    .required('Passwords must match') */
